import { axiosInstance } from '@/lib/axios';
import { ProcessedFilesDetails } from './types';

type Props = {
  companyId: string
  fileId: string
}

export function getProcessedFiles ({ companyId, fileId }: Props) {
    return axiosInstance.get<ProcessedFilesDetails>(`/api/${companyId}/fileProcessing/processedFilesById?&id=${fileId}
`);
}
